
import { useEffect, useState } from 'react';
import PoleCreateUpdateFormView, { DataForm } from './PoleCreateUpdateFormView/PoleCreateUpdateFormView'
import { PolePatch } from '../../../types/planBT.types';
import { usePoles, useSinglePole } from '../../../hooks';

import { useMicroNavigator } from '../../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext';
import validationPoleCheck, { ErrorInputPole } from '../../../utils/validationPole';


interface PoleCreateUpdateFormProps  {
  isUpdate?: boolean
  variant?: "dark" | "light"
}

export default function PoleCreateUpdateFormPresenter({variant= "dark", isUpdate}: PoleCreateUpdateFormProps) {

  const { createPoleToPlanBT:{mutate, isLoading, error} } = usePoles();
  const {singlePoleQuery:{data:singlePole}, updateSinglePoleQuery} = useSinglePole()
  const {navigate} = useMicroNavigator();
  
  const [dataForm, setDataForm] = useState<DataForm | null>(null);
  const [errorForm, setErrorForm] = useState<ErrorInputPole| null>(null);

  const convertDataFormToPole = (dataForm: DataForm | null)  : PolePatch=> {
    return {
      pole_name: dataForm?.name,
      pole_number: dataForm?.number,
      pole_location_lat: dataForm?.location?.latitude || 0,
      pole_location_lng: dataForm?.location?.longitude || 0
    }
  }



  useEffect(() => {
    if(singlePole){
      setDataForm({
        name: singlePole.pole_name,
        number: singlePole.pole_number,
        location: {
          latitude: singlePole.pole_location_lat,
          longitude: singlePole.pole_location_lng
        }
      })
    }
  },[singlePole]) // eslint-disable-line

  const handleSubmit = () => {
   
    const poleToSend = convertDataFormToPole(dataForm);

    //TODO : chech if dataForm is valid

    const haveError = validationPoleCheck(poleToSend)

    if(haveError){
      setErrorForm(haveError)
      return
    }

    if(isUpdate){

      updateSinglePoleQuery.mutate({pole: poleToSend, callback: (rep) => {
        if(rep.result){
          navigate('single', {poleId: rep.result.pole_id})
        }
      }})

    }else{

      //Create
      if(dataForm){
        mutate({newPole: poleToSend, callbackFunc: (rep) => {
          if(rep.result){
           
            setDataForm(null)
            navigate('single', {poleId: rep?.result?.pole_id})
          }
        }}) 
      }


    }
  }

  if(isUpdate && !singlePole){
    return <p>Loading...</p>
  }

  return (
    <PoleCreateUpdateFormView  errorForm={errorForm} eroorMessage={updateSinglePoleQuery?.error?.message || error?.message} variant={variant} isUpdate={isUpdate} isLoading={isLoading || updateSinglePoleQuery.isLoading}  dataForm={dataForm} setDataForm={setDataForm} handleSubmit={handleSubmit} labelSubmitBtn={isUpdate ? 'Modifier' : 'Créer'}/>
  )
}
